import { Pathname } from 'constants/data'

const getBaseUrl = (type: string | undefined): string => {
  let result = ''

  switch (type) {
    case 'webinar':
      result = Pathname.WEBINAR
      break
    case 'article':
      result = Pathname.ARTICLE
      break
    default:
  }
  return result
}

export { getBaseUrl }
